export type ImportMode = 'SKIP' | 'UPDATE' | 'ERROR';

export type ImportKind = 'contacts' | 'companies' | 'contacts+companies';

export interface ImportRowError {
  rowNumber: number;
  field?: string | null;
  message: string;
}

export interface ImportResultResponse {
  kind: ImportKind | string;
  totalRows: number;
  created: number;
  updated: number;
  skipped: number;
  failed: number;
  errors: ImportRowError[];
}

export const MAX_IMPORT_FILE_BYTES = 5 * 1024 * 1024;
export const MAX_IMPORT_DATA_ROWS = 5000;
